class StripeCardOrSubPaymentRequest {

    config: any;
    key: string;
    currentAmount: Function;
    readCookie: Function;
    isBlank: Function;
    isOrderFulfilled: Function;
    elements: any;
    stripe: any;
    paymentIntentId: string;
    modal: HTMLElement;
    modalOverlay: HTMLElement;
    paymentMessage: HTMLElement;
    nextButton: HTMLButtonElement;
    cancelButton: HTMLButtonElement;
    customerId: string;
    spinner: HTMLElement;
    paymentForm: HTMLElement;
    currentStep: number;
    modalTitle: HTMLElement;
    customerEmail: string;

    constructor(config: any, key: string, getPayAmount: Function, readCookie: Function, isOrderFulfilled: Function) {
        this.config = config;
        this.key = key;

        this.modal = document.querySelector("#stripe-modal");
        this.modalOverlay = document.querySelector("#stripe-modal-overlay");
        
        this.paymentMessage = document.querySelector("[data-payment-response-message]");

        this.nextButton = document.querySelector("[data-button-next]");
        this.cancelButton = document.querySelector("[data-button-cancel]");

        this.openPaymentModal = this.openPaymentModal.bind(this);
        this.modalClose = this.modalClose.bind(this);

        this.spinner = document.querySelector(".spinner-container");
        this.paymentForm = document.querySelector("#payment-form");
        this.modalTitle = document.querySelector(".modal-header h4");

        this.currentStep = 1;

        this.currentAmount = () => {
            return getPayAmount();
        }
        this.addEvents();
        this.readCookie = readCookie;
        this.isOrderFulfilled = isOrderFulfilled;
        this.isBlank = (str) => {
            return (!str || /^\s*$/.test(str));
        }
        if (config.general.stripeConnectId && config.general.stripeConnectId.trim()) {
            this.stripe = (<any>window).Stripe(key,
                {
                    stripeAccount: config.general.stripeConnectId
                }) as any;
        } else {
            this.stripe = (<any>window).Stripe(key) as any; // Get stripe from Global window.
        }
    }

    addEvents = () => {
        const stripeBtn = document.getElementById("stripeButton") as HTMLButtonElement;

        stripeBtn.addEventListener("click", this.openPaymentModal);

        const emailInputElement = document.getElementById("email") as HTMLInputElement;
        emailInputElement.addEventListener("focusout", () => {
            this.validateEmail(emailInputElement);
        });
        emailInputElement.addEventListener("input", () => {
            this.clearEmailValidation(emailInputElement);
        });

        this.modal.addEventListener("click", () => {
            this.clearPaymentMessage();
        });

        this.cancelButton.addEventListener("click", () => {
            this.currentStep = 1;
            return this.modalClose();
        });

        this.nextButton.addEventListener("click", async (e) => {
            
            if (this.currentStep === 1) {
                await this.getOrCreateCustomer(e);

                if (this.customerId == null)
                    return;

                await this.mountPaymentElement();
            } else if (this.currentStep === 2) {
                const error = await this.submitPayment(e);

                if (error !== null)
                    return;
            }

            this.currentStep++;
            this.showStep();
        });
    }

    modalClose() {
        this.modal.classList.toggle("closed");
        this.modalOverlay.classList.toggle("closed");
        this.modal.classList.remove("stripe-modal-full");
        this.modal.classList.add("stripe-modal-compact");
    }

    showStep() {
        const pages = document.querySelectorAll("[data-step]");

        for (var i = 0, len = pages.length; i < len; i++) {
            const dataStep = parseInt(pages[i].getAttribute("data-step"));

            if (dataStep === this.currentStep) {
                pages[i].classList.remove("hidden");
                this.modalTitle.textContent = pages[i].getAttribute("data-step-title");
                this.nextButton.textContent = pages[i].getAttribute("data-step-next-button");
            } else {
                pages[i].classList.add("hidden");
            }
                
        }
    }

    async openPaymentModal(e: Event) {

        await this.showStep();
        
        this.modal.classList.toggle("closed");
        this.modalOverlay.classList.toggle("closed");
        
        this.modal.classList.remove("stripe-modal-full");
        this.modal.classList.add("stripe-modal-compact");
        
        e.preventDefault();
    }
    
    clearEmailValidation(emailInputElement: HTMLInputElement) {
        const emailValidationMessageElement = document.querySelector("[data-email-validation-message]") as HTMLSpanElement;

        // Reset validation element
        emailValidationMessageElement.textContent = "";
        emailValidationMessageElement.classList.remove("input__helper-text-error");
        emailInputElement.classList.remove("input-invalid");
    }

    validateEmail(emailInputElement: HTMLInputElement):boolean {
        let isValid = true;
        const emailValidationMessageElement = document.querySelector("[data-email-validation-message]") as HTMLSpanElement;

        this.clearEmailValidation(emailInputElement);

        if (emailInputElement.value === "" || emailInputElement.value == null) {
            emailValidationMessageElement.textContent = "Please enter an email address";
            emailValidationMessageElement.classList.add("input__helper-text-error");
            emailInputElement.classList.add("input-invalid");
            isValid = false;
        }

        return isValid;
    }

    async getOrCreateCustomer(e) {
        e.preventDefault();

        this.setLoading(true);

        const emailInputElement = document.getElementById("email") as HTMLInputElement;

        const isValid = this.validateEmail(emailInputElement);

        if (!isValid) {
            this.setLoading(false);
            return;
        }
            
        // Create customer
        const createCustomerRequest: object = {
            companyId: this.config.general.companyId,
            demo: this.config.general.demoMode,
            email: emailInputElement.value,
        };

        const emailResponse = await fetch("/Stripe/GetOrCreateCustomer", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(createCustomerRequest),
        });

        const { customerId } = await emailResponse.json();

        this.customerId = customerId;
        this.customerEmail = emailInputElement.value;
        
        this.setLoading(false);
    }

    async mountPaymentElement() {

        this.setLoading(true);

        const createPaymentIntentRequest: object = {
            demo: this.config.general.demoMode,
            currencyCode: this.config.general.isoCurrencySymbol.toLowerCase(),
            amount: this.currentAmount().unitValue,
            interactionId: this.config.general.interactionId,
            goalType: this.config.general.goalTypeInt,
            version: this.config.general.version,
            description: this.config.general.paymentDescription,
            companyId: this.config.general.companyId,
            customerId: this.customerId,
            meta: this.config.general.meta,
            isSubscription: this.config.general.isSubscription,
            subscriptionPlanId: this.config.general.planID
        };

        const response = await fetch("/Stripe/CreatePaymentIntent", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(createPaymentIntentRequest),
        });

        const { clientSecretKey, paymentIntentId } = await response.json();

        this.paymentIntentId = paymentIntentId;

        const appearance = {
            theme: 'stripe',
        };

        this.elements = this.stripe.elements({ appearance, clientSecret: clientSecretKey });

        this.setLoading(false);

        const paymentElement = this.elements.create("payment", { wallets: { applePay: 'never', googlePay: 'never' } });
        paymentElement.mount("#payment-element");
    }

    async submitPayment(e) {
        e.preventDefault();

        this.setLoading(true);
        
        const elements = this.elements;

        const { error } = await this.stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: `${this.config.general.stripeRedirectUrl}&donationAmount=${this.currentAmount().value}&email=${this.customerEmail}`
            },
        });

        // This point will only be reached if there is an immediate error when
        // confirming the payment. Otherwise, your customer will be redirected to
        // your `return_url`. For some payment methods like iDEAL, your customer will
        // be redirected to an intermediate site first to authorize the payment, then
        // redirected to the `return_url`.
        if (error.type === "card_error" || error.type === "validation_error") {
            this.showPaymentMessage(error.message);
        } else {
            this.showPaymentMessage("An unexpected error occurred. Please try again later.");
        }

        this.setLoading(false);

        return error;
    }
    
    // Fetches the payment intent status after payment submission
    async checkStatus() {
        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );

        if (!clientSecret) {
            return;
        }

        const { paymentIntent } = await this.stripe.retrievePaymentIntent(clientSecret);
        
        switch (paymentIntent.status) {
            case "succeeded":
                this.showPaymentMessage("Payment succeeded!");
                break;
            case "processing":
                this.showPaymentMessage("Your payment is processing.");
                break;
            case "requires_payment_method":
                this.showPaymentMessage("Your payment was not successful, please try again.");
                break;
            default:
                this.showPaymentMessage("Something went wrong.");
                break;
        }
    }

    // ------- UI helpers -------

    showPaymentMessage(messageText) {
        this.paymentMessage.classList.remove("hidden");
        this.paymentMessage.textContent = messageText;
    }

    clearPaymentMessage() {
        this.paymentMessage.classList.add("hidden");
        this.paymentMessage.textContent = "";
    }

    // Show a spinner on payment submission
    setLoading(isLoading) {
        if (isLoading) {
            // Disable the button and show a spinner
            this.nextButton.disabled = true;
            this.cancelButton.disabled = true;
            this.spinner.classList.remove("hidden");
            this.paymentForm.classList.add("hidden");
        } else {
            this.nextButton.disabled = false;
            this.cancelButton.disabled = false;
            this.spinner.classList.add("hidden");
            this.paymentForm.classList.remove("hidden");
        }
    }
}

export default StripeCardOrSubPaymentRequest;
